const initialState = {
  counter: 0,
  information: {
    userName: "",
    emailAddress: "",
    language: "",
    communication: "",
  },
  changePassword: {},
  verification: {
    emailAddress: {
      status: "",
      message: "",
    },
    mobileNumber: {
      status: "",
      message: "",
    },
    govtId: {
      status: "",
      message: "",
    },
  },
};

export default initialState;
